import React, { useCallback } from "react";
import * as Scrivito from "scrivito";
import ReactSelect, { type MultiValue, type ActionMeta } from "react-select";

type MultiselectProps = {
  options: Record<string, string>[];
  optionsSelected: Record<string, string>[];
  handleChange: (
    values: Record<string, string>[],
    actionMeta?: ActionMeta<Record<string, string>>,
  ) => void;
};

export const Multiselect = Scrivito.connect(
  ({ options = [], optionsSelected = [], handleChange }: MultiselectProps) => {
    const onChange = useCallback(
      (
        values: MultiValue<Record<string, string>>,
        actionMeta: ActionMeta<Record<string, string>>,
      ) => {
        handleChange([...values], actionMeta);
      },
      [handleChange],
    );

    return (
      <ReactSelect
        placeholder="Select"
        isMulti
        value={optionsSelected}
        options={options}
        onChange={onChange}
      />
    );
  },
);
